module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms-landing"
  }, [(_vm.isUserSubscribed) ? _c('v-container', {
    attrs: {
      "grid-list-xs": "",
      "fluid": "",
      "pa-0": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "sm3": "",
      "conversation-list": ""
    }
  }, [_c('div', {
    staticClass: "_intro"
  }, [_c('div', {
    staticClass: "_title app-bold"
  }, [_vm._v("Sent SMS")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n            " + _vm._s(_vm.smsCount) + " text " + _vm._s(_vm._f("pluralize")("message", _vm.smsCount)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "conversation-content"
  }, _vm._l((_vm.smsList), function(message, index) {
    return _c('div', {
      key: index,
      staticClass: "message",
      on: {
        "click": function($event) {
          _vm.openMessage(message.id)
        }
      }
    }, [_c('user-tag', {
      attrs: {
        "user": _vm.currentUser,
        "showAvatar": "",
        "hideTick": "",
        "hideName": "",
        "width": "37.7",
        "height": "37.5",
        "clickUser": false
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "message-recipient"
    }, [_vm._v("teekomusic")]), _vm._v(" "), _c('div', {
      staticClass: "message-trunc"
    }, [_vm._v("\n                " + _vm._s(message.message) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "messaged-time"
    }, [_vm._v("\n                " + _vm._s(_vm._f("toLocalTimeString")(message.created_at)) + "\n              ")])])], 1)
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm9": "",
      "conversation-card": ""
    }
  }, [_c('div', {
    staticClass: "_intro"
  }, [_vm._v("\n          Send SMS text to "), _c('strong', [_vm._v("2,343 people")]), _vm._v(" on your sms list\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.smsEngagementActive) ? _c('sms-engagement', {
    attrs: {
      "item": _vm.currentMessage
    },
    on: {
      "closeEngagement": _vm.closeEngagement
    }
  }) : _vm._e()], 1)], 1)])], 1)], 1) : _c('v-container', {
    attrs: {
      "grid-list-xs": "",
      "fluid": "",
      "pa-0": "",
      "sms-community": "",
      "not-subscribed": "",
      "allChildrenCenter": ""
    }
  }, [_c('div', {
    staticClass: "text-center _wrapper"
  }, [_c('h1', {
    staticClass: "_intro-text"
  }, [_vm._v("Reach your community through text.")]), _vm._v(" "), _c('img', {
    staticClass: "my-5",
    attrs: {
      "src": require('@/assets/sms_chat.svg'),
      "width": "40%",
      "alt": "sms chat"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n        You have "), _c('strong', [_vm._v("2,039 people")]), _vm._v(" on your SMS contact list.\n        Subscribe to text them!\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 px-3",
    attrs: {
      "depressed": "",
      "round": "",
      "dark": ""
    },
    on: {
      "click": _vm.initSubscribe
    }
  }, [_vm._v("\n        Subscribe\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20bdedf2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMS/landing.vue
// module id = 1647
// module chunks = 180